import React, { lazy } from "react";
import styled from "styled-components";
import { Row, Col, Container } from "react-bootstrap";
import Fade from 'react-reveal/Fade';
import recent_project_list from "../../data/ourRecentPjt";
// import html5 from "../../assets/html5.png";
import Carousel from "react-elastic-carousel";

const Ourprojects = () => {
const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 2 },
    { width: 1200, itemsToShow: 1 },
    ];
      
const project_list = recent_project_list;
console.log(project_list);
return  <>

            <Container fluid className="ourprojects">
                <Row>
                    <Fade bottom><center><h2 className="ourpjtheadName"><b>Our Recent Projects</b></h2></center></Fade>
                </Row>
                <div>
                    <Carousel breakPoints={breakPoints} pagination={false}>
                        {project_list.map(function(t,i){
                            return (
                                <div className="ourprojectscard">
                                        <Fade left>
                                            <div className="" >
                                                    <div className="ourPjtname"><center><h2>{t.name}</h2></center></div>
                                                    <div className="ourPjtdes"><center><i><label>"{t.description}"</label></i></center></div>
                                                    <a href={t.src}>
                                                        <img src={t.img} alt="ourWork" className="ourPjtimg"/>
                                                    </a>
                                                    {/* <iframe src={t.src} frameborder="0"></iframe> */}
                                               
                                            </div>
                                        </Fade> 
                                </div>
                            );
                        })}
                    </Carousel>
                </div>
            </Container>
        </>
}

export default Ourprojects;

